const MarketplaceModule = () => import('@pages/marketplace/MarketplaceModule.vue')
const MarketplaceIndex = () => import('@pages/marketplace/Index.vue')
const MarketplaceItemDetails = () => import('@pages/marketplace/ItemDetails.vue')
const MarketplaceSellers = () => import('@pages/marketplace/sellers/Index.vue')
const MarketplaceSellerUsers = () => import('@pages/marketplace/sellers/users/Index.vue')
const SellerMarketplaceItemIndex = () => import('@pages/marketplace/sellerItems/Index.vue')
const SellerMarketplaceItemDetails = () => import('@pages/marketplace/sellerItems/ItemDetails.vue')
export default {
    path: 'marketplace',
    component: MarketplaceModule,
    children: [
        {
            path: 'marketplace-index',
            component: MarketplaceIndex,
            name: 'marketplace', 
        },
        {
            path: 'item-details/:slug/:itemId',
            component: MarketplaceItemDetails,
            name: 'marketplaceItemDetails', 
            props: true,
        },
        {
            path: 'marketplace-sellers',
            component: MarketplaceSellers,
            name: 'marketplaceSellers',
        },
        {
            path: ':sellerId/marketplace-seller-users',
            component: MarketplaceSellerUsers,
            name: 'marketplaceSellerUsers',
            props: true,
        },
        {
            path: 'seller-marketplace-index',
            component: SellerMarketplaceItemIndex,
            name: 'sellerMarketplaceIndex', 
        },
        {
            path: 'item-details/:slug/:itemId',
            component: SellerMarketplaceItemDetails,
            name: 'sellerMarketplaceItemDetails', 
            props: true,
        },
    ],
}
